import { combineReducers } from 'redux';
import { authReducer } from './auth/reducer';
// eslint-disable-next-line import/no-cycle
import { lookupsReducer } from './lookups/reducer';

export const rootReducer = combineReducers({
    auth: authReducer,
    lookups: lookupsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
